
import { isEmpty } from "./constants"

export default function logger(data) {
  if (!isEmpty("process.env.REACT_APP_IS_LOGGER")) {
    if (data.info) {
      console.info(data.info)
    }
    if (data.error) {
      console.info(data.error)
    }
  }
}

export function checkNextPage(paginationInfo) {

  const totalPages = Math.ceil(paginationInfo.totalRecords / paginationInfo.limit);
  const isNextPage = paginationInfo.page < Math.ceil(totalPages);

  if(isNextPage){
    paginationInfo.nextPage = paginationInfo.page + 1
  }else{
    paginationInfo.nextPage = null
  }

  paginationInfo.totalPages = totalPages;
  paginationInfo.isNextPage = isNextPage;

  return paginationInfo;
}

export const headCells = [
  {
    id: "student_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "grade_name",
    numeric: false,
    disablePadding: false,
    label: "Grade Level",
  },
  {
    id: "mentor_name",
    numeric: false,
    disablePadding: false,
    label: "Mentor",
  },
  {
    id: "progress",
    numeric: false,
    disablePadding: false,
    label: "Progress",
  },
  {
    id: "last_date",
    numeric: false,
    disablePadding: false,
    label: "Last Meeting",
  },
];

export const headCellsForMentorRole = [
  {
    id: "student_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "grade_name",
    numeric: false,
    disablePadding: false,
    label: "Grade Level",
  },
  {
    id: "progress",
    numeric: false,
    disablePadding: false,
    label: "Progress",
  },
  {
    id: "last_date",
    numeric: false,
    disablePadding: false,
    label: "Last Meeting",
  },
];

export const headCellForSuperAdmin = [
  {
    id: "student_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "grade_name",
    numeric: false,
    disablePadding: false,
    label: "Grade Level",
  },
  {
    id: "district_name",
    numeric: false,
    disablePadding: false,
    label: "District",
  },
  {
    id: "mentor_name",
    numeric: false,
    disablePadding: false,
    label: "Assigned Mentor",
  },
  {
    id: "last_date",
    numeric: false,
    disablePadding: false,
    label: "Last Meeting",
  },
  // {
  //   id: "progress",
  //   numeric: false,
  //   disablePadding: false,
  //   label: "Progress",
  // },
  {
    id: "plan",
    numeric: false,
    disablePadding: false,
    label: "Plan",
  }
  
];

export const headCellForMentorList = [
  {
    id: "mentor_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "mobile",
    numeric: false,
    disablePadding: false,
    label: "Phone No",
  },
  {
    id: "university_name",
    numeric: false,
    disablePadding: false,
    label: "University",
  },
  {
    id: "strike",
    numeric: false,
    disablePadding: false,
    label: "Strikes",
  }
  
];

export const headCellsForMentorsForSchoolAdmin = [
  {
    id: "mentor_name",
    numeric: false,
    disablePadding: false,
    label: "Name",
  },
  {
    id: "email",
    numeric: false,
    disablePadding: false,
    label: "Email",
  },
  {
    id: "last_date",
    numeric: false,
    disablePadding: false,
    label: "Last Meeting",
  },
];

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] == null || b[orderBy] === undefined) {
    return -1;
  }
  if (a[orderBy] == null || a[orderBy] === undefined) {
    return 1;
  }
  // Check if values are strings
  if (typeof a[orderBy] === 'string' && typeof b[orderBy] === 'string') {
    return b[orderBy].localeCompare(a[orderBy]);
  }

  // Check if values are numbers
  if (typeof a[orderBy] === 'number' && typeof b[orderBy] === 'number') {
    return b[orderBy] - a[orderBy];
  }

  // Default case: handle alphanumeric values
  const stringA = String(a[orderBy]).toLowerCase();
  const stringB = String(b[orderBy]).toLowerCase();

  if (stringA < stringB) {
    return -1;
  }
  if (stringA > stringB) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array?.map((el, index) => [el, index]);
  stabilizedThis?.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis?.map((el) => el[0]);
}


export const headCellForCreditList = [
  {
    id: "student_name",
    numeric: false,
    disablePadding: false,
    label: "Student Name",
  },
  {
    id: "total_required_credits_doc_type",
    numeric: false,
    disablePadding: false,
    label: "Doc Credits",
  },
  {
    id: "total_required_credits_meeting_plans",
    numeric: false,
    disablePadding: false,
    label: "Meeting Credits",
  }  
];

export const headCellForHelpSupportList = [  {
  id: "name",
  numeric: false,
  disablePadding: false,
  label: "Name",
},
{
  id: "role",
  numeric: false,
  disablePadding: false,
  label: "Role",
},
{
  id: "type_of_request",
  numeric: false,
  disablePadding: false,
  label: "Request Type",
},
{
  id: "user_type",
  numeric: false,
  disablePadding: false,
  label: "User Type",
},
{
  id: "raised_on",
  numeric: false,
  disablePadding: false,
  label: "Date",
},
{
  id: "comment",
  numeric: false,
  disablePadding: false,
  label: "Comment",
}]